import * as React from "react";
import styles from "./CenteredContainer.module.css";

export interface CenteredContainerProps {
  children: React.ReactNode;
  /** Whether to take full height of the parent (default: true) */
  fullHeight?: boolean;
  /** Additional className */
  className?: string;
}

/**
 * A flex container that centers its children both horizontally and vertically.
 * Commonly used for loading spinners, empty states, and error messages.
 *
 * Usage:
 * ```tsx
 * <CenteredContainer>
 *   <Spinner size="lg" />
 * </CenteredContainer>
 * ```
 */
export function CenteredContainer({
  children,
  fullHeight = true,
  className,
}: CenteredContainerProps) {
  const combinedClass = [
    styles.container,
    fullHeight ? styles.fullHeight : undefined,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <div className={combinedClass}>{children}</div>;
}
